// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__240KL","menuLink":"Navbar_menuLink__28BY5","activeLink":"Navbar_activeLink__fFNzX","menuIcon":"Navbar_menuIcon__2bAdI"};